import { Navigate, Route, Routes } from 'react-router-dom'
import DevToolsPage from './DevToolsPage'
import TransactionRetryPage from './TransactionRetryPage'

const AdminRouter = () => {
  return (
    <Routes>
      <Route path="transaction-retry" element={<TransactionRetryPage />} />
      <Route path="dev-tools" element={<DevToolsPage />} />
      <Route path="" element={<Navigate to="transaction-retry" replace />} />
      <Route path="*" element={<Navigate to=".." replace />} />
    </Routes>
  )
}

export default AdminRouter
